import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { markApprovedRejectedAgencyFailure, markApprovedRejectedAgencySuccess } from '../../actions/agencyActions/markApprovedRejectedAgencyActions';

function* markApprovedRejectedAgency({ payload }) {
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.markApprovedRejectedAgency,
            payload,
            isAuth: true,
        });
        yield put(markApprovedRejectedAgencySuccess({
            status: response?.data?.status,
            response: response?.data?.response,
            message: response?.data?.message,
        }));
    } catch (error) {
        yield put(markApprovedRejectedAgencyFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message,
        }));
    }
}

function* markApprovedRejectedAgencySaga() {
    yield takeLatest(actionTypes.MARK_APPROVED_REJECTED_AGENCY_REQUEST, markApprovedRejectedAgency);
}

export default markApprovedRejectedAgencySaga;
